import * as action_types from "./constants";
import { GetLaborRatesType } from "./types";

export type crewYardState = {
  laborData: {
    loader: boolean;
    data: GetLaborRatesType[] | null;
  };
};

const initialState: crewYardState = {
  laborData: {
    loader: true,
    data: null,
  },
};

type MyDataActionType = {
  type: typeof action_types.GET_LABOR_RATE;
  data: { payload: []; loading: boolean };
};

const myTeamReducer = (
  state = initialState,
  action: MyDataActionType
): crewYardState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_LABOR_RATE:
      return {
        ...state,
        laborData: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    default:
      return state;
  }
};

export default myTeamReducer;
